const NarrationStateEnum = {
  mediaBufferState: 5
};

export { NarrationStateEnum };
